import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";

export default function NameCheckFaq({ faqs }) {
  return (
    <section
      id="name-check-faq"
      className="border-t border-black/10 bg-white"
      data-testid="name-check-faq"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="flex items-center gap-2 text-xs font-semibold tracking-[0.22em] uppercase text-[#EAB308]">
          <HelpCircle size={14} /> Frequently Asked
        </div>
        <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight mt-3 leading-[1.05]">
          Check Company Name Availability — Common Questions
        </h2>
        <p className="mt-4 text-black/70 max-w-2xl">
          Everything Indian founders ask before running a{" "}
          <b>startup name availability</b> search on MCA, domains and the
          trademark registry.
        </p>

        <div className="mt-10 divide-y divide-black/10 border-t border-b border-black/10">
          {faqs.map((f, i) => (
            <FaqRow key={f.q} idx={i} q={f.q} a={f.a} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqRow({ idx, q, a }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div data-testid={`faq-row-${idx}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid={`faq-trigger-${idx}`}
        className="w-full flex items-center justify-between gap-4 py-5 text-left"
      >
        <span className="font-heading font-bold text-base sm:text-lg leading-snug">
          {q}
        </span>
        <ChevronDown
          size={18}
          className={`shrink-0 text-[#EAB308] transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <p
          data-testid={`faq-answer-${idx}`}
          className="pb-6 text-sm sm:text-base text-black/75 leading-relaxed"
        >
          {a}
        </p>
      )}
    </div>
  );
}
